module.exports = __webpack_public_path__ + "static/media/wifi.2daf3490.png";